import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Input } from '@ui/components/Input';

import { NewsPost } from '@features/shared/api/typings';

export function TitleInput() {
  const { control } = useFormContext<NewsPost>();

  return (
    <FormRow>
      <FormLabel>Заголовок</FormLabel>
      <FormInput>
        <Controller
          name="title"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Input invisible value={value as string} onChange={onChange} disabled={disabled} />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
